import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './Back.css'; // Ensure this path is correct

function Back() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/home"); // Navigate to the previous page in history
  };

  return (
    <button
      onClick={handleGoBack}
      aria-label="Go home"
    >
      <FontAwesomeIcon icon={faArrowLeft} size="2x" />
    </button>
  );
}

export default Back;
